import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotification = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 12,
	viewBox: "0 0 15 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M2.06,5.07H.56c-.31,0-.56-.25-.56-.56s.25-.56,.56-.56h1.5c.31,0,.56,.25,.56,.56s-.25,.56-.56,.56ZM.92,1.05c0-.2,.11-.39,.28-.49,.18-.1,.4-.1,.57,0l1.3,.75c.18,.1,.29,.28,.29,.49,0,.2-.11,.39-.28,.49-.18,.1-.4,.1-.57,0l-1.3-.75c-.18-.1-.29-.28-.29-.49Zm11.63,7.44c.13,.14,.2,.32,.2,.51,0,.38-.31,.75-.75,.75H3c-.45,0-.75-.37-.75-.75,0-.21,.07-.37,.2-.51,.45-.48,1.3-1.21,1.3-3.6,0-1.84,1.27-3.27,3-3.63v-.49c0-.27,.13-.53,.37-.67,.23-.14,.53-.14,.76,0,.23,.14,.38,.39,.37,.67v.49c1.72,.36,3,1.81,3,3.63,0,2.39,.85,3.12,1.3,3.6Zm-8.72,.14h7.34c-.5-.66-1.04-1.74-1.04-3.73h0c0-1.46-1.17-2.63-2.62-2.63s-2.62,1.17-2.62,2.62h0c0,2-.54,3.09-1.04,3.74h0Zm2.17,1.87h3c0,.83-.67,1.5-1.52,1.5s-1.48-.67-1.48-1.5ZM11.67,1.95c-.06-.25,.04-.51,.26-.63l1.3-.75c.27-.15,.61-.06,.76,.21,.15,.26,.07,.6-.2,.76l-1.3,.75c-.09,.05-.18,.08-.28,.08-.26,0-.48-.17-.54-.42Zm3.33,2.57c0,.31-.25,.56-.56,.56h-1.5c-.31,0-.56-.25-.56-.56s.25-.56,.56-.56h1.5c.31,0,.56,.25,.56,.56Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgNotification);
export default ForwardRef;
